/* Contact lenses ship to US addresses only (Grant, 14.10.2026).
   Loaded by layout/theme.liquid only when the market country is not US.
   Any checkout click (cart page, cart drawers) is caught in the capture phase on
   window — before Global-e or the theme handlers — and blocked if the cart holds a
   product of type "Contact Lenses". Safety net only: the real block is excluding
   these products from non-US market catalogs. */
(function () {
  var MSG = window.hgClUsOnlyMsg || 'Contact lenses ship to US addresses only.';
  var SEL = '[name="checkout"], #checkout, #hg-cart-checkout-btn, a[href="/checkout"], a[href^="/checkout?"]';
  var pending = false;

  function hasCl(cart) {
    return (cart.items || []).some(function (i) { return i.product_type === 'Contact Lenses'; });
  }

  function notice(btn) {
    var box = btn.parentNode.querySelector('.hg-cl-us-only-cart');
    if (!box) {
      box = document.createElement('p');
      box.className = 'hg-cl-us-only-cart';
      box.setAttribute('role', 'alert');
      box.style.cssText = 'margin:1rem 0;padding:1rem 1.4rem;background:#fff4f4;border:1px solid #e3a0a0;border-radius:.8rem;color:#8a1f1f;font-size:1.6rem;line-height:2.2rem';
      btn.parentNode.insertBefore(box, btn);
    }
    box.textContent = MSG;
  }

  window.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest(SEL);
    if (!btn || btn.dataset.hgClOk === '1') return;
    e.preventDefault();
    e.stopPropagation();
    if (pending) return;
    pending = true;
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        pending = false;
        if (hasCl(cart)) { notice(btn); return; }
        /* No contact lenses — let this click through as if nothing happened. */
        btn.dataset.hgClOk = '1';
        btn.click();
        delete btn.dataset.hgClOk;
      })
      .catch(function () {
        pending = false;
        btn.dataset.hgClOk = '1';
        btn.click();
        delete btn.dataset.hgClOk;
      });
  }, true);
})();
